import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiStar, FiUser } = FiIcons;

const Reviews = () => {
  const reviews = [
    {
      author: "Aurelia Ranoux",
      rating: 5,
      date: "6 years ago",
      review: "Very well equipped, the people are adorable. And no heavyweights playing the kikous, to try to show off, nor heavy-handed people trying to flirt! In short, a small family club where you can practice cardio and weight training with pleasure."
    },
    {
      author: "David Chassin",
      rating: 5,
      date: "5 years ago",
      review: "Very well equipped room, renewed equipment, nice people..."
    },
    {
      author: "Théo Mazeres",
      rating: 4,
      date: "8 years ago",
      review: "Nice center for doing sports"
    },
    {
      author: "Delphine Rossi",
      rating: 5,
      date: "7 years ago",
      review: "Dynamic and friendly team"
    },
    {
      author: "david saurel",
      rating: 5,
      date: "4 months ago",
      review: "Excellent experience! Highly recommend this gym for anyone looking for quality equipment and a welcoming atmosphere."
    },
    {
      author: "Stephane Bezes",
      rating: 5,
      date: "7 years ago",
      review: "Outstanding facility with top-notch equipment and friendly staff."
    },
    {
      author: "leonardo fabio tombe gomez",
      rating: 5,
      date: "7 years ago",
      review: "Great gym with a wonderful community feel. Perfect for all fitness levels."
    },
    {
      author: "Djamel Ayachi",
      rating: 5,
      date: "7 years ago",
      review: "Amazing place to work out. Clean, modern, and welcoming environment."
    },
    {
      author: "Magali Delonca",
      rating: 5,
      date: "7 years ago",
      review: "Love this gym! The equipment is always in great condition and the atmosphere is fantastic."
    },
    {
      author: "Zakaria Benouzza",
      rating: 5,
      date: "7 years ago",
      review: "Highly professional staff and excellent facilities. Couldn't ask for more!"
    },
    {
      author: "Maël ROQUE",
      rating: 4,
      date: "8 years ago",
      review: "Good gym with solid equipment and friendly people."
    }
  ];

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <SafeIcon
        key={index}
        icon={FiStar}
        className={`w-5 h-5 ${
          index < rating 
            ? 'text-yellow-500 fill-current' 
            : 'text-gray-400'
        }`}
      />
    ));
  };

  const averageRating = reviews.reduce((sum, review) => sum + review.rating, 0) / reviews.length;
  const totalReviews = reviews.length;

  return (
    <div className="pt-20">
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-r from-black via-gray-900 to-black">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8 }}
            className="text-center max-w-4xl mx-auto"
          >
            <h1 className="text-5xl md:text-6xl font-bold mb-6">
              Member <span className="text-yellow-500">Reviews</span>
            </h1>
            <p className="text-xl text-gray-300 mb-8">
              See what our amazing community has to say about their experience
            </p>
            
            {/* Rating Summary */}
            <div className="bg-gradient-to-r from-yellow-500/20 to-yellow-600/20 p-8 rounded-2xl border border-yellow-500/30 max-w-md mx-auto">
              <div className="flex items-center justify-center space-x-2 mb-4">
                {renderStars(Math.round(averageRating))}
              </div>
              <p className="text-3xl font-bold text-yellow-500 mb-2">
                {averageRating.toFixed(1)} out of 5
              </p>
              <p className="text-gray-300">
                Based on {totalReviews} reviews
              </p>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Reviews Grid */}
      <section className="py-20 bg-black">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {reviews.map((review, index) => (
              <motion.div
                key={index}
                initial={{ y: 50, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
                whileHover={{ y: -5 }}
                className="bg-gradient-to-b from-gray-900 to-black p-6 rounded-2xl border border-yellow-500/20 hover:border-yellow-500/50 transition-all duration-300"
              >
                {/* Header */}
                <div className="flex items-start justify-between mb-4">
                  <div className="flex items-center space-x-3">
                    <div className="bg-gradient-to-r from-yellow-500 to-yellow-600 w-12 h-12 rounded-full flex items-center justify-center">
                      <SafeIcon icon={FiUser} className="text-black text-lg" />
                    </div>
                    <div>
                      <h3 className="font-bold text-white text-lg">
                        {review.author}
                      </h3>
                      <p className="text-gray-400 text-sm">
                        {review.date}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Rating */}
                <div className="flex items-center space-x-1 mb-4">
                  {renderStars(review.rating)}
                </div>

                {/* Review Text */}
                <p className="text-gray-300 leading-relaxed">
                  "{review.review}"
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-20 bg-gradient-to-r from-yellow-500 to-yellow-600">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ y: 50, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center"
          >
            <h2 className="text-4xl md:text-5xl font-bold mb-6 text-black">
              Ready to Join Our Community?
            </h2>
            <p className="text-xl text-black/80 mb-8 max-w-2xl mx-auto">
              Experience the difference that our members are talking about. 
              Start your fitness journey with us today!
            </p>
            <button className="bg-black text-yellow-500 px-8 py-4 rounded-full font-bold text-lg hover:bg-gray-900 transition-all duration-300 transform hover:scale-105">
              Get Started Now
            </button>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Reviews;